/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage, injectIntl } from 'react-intl';

// Messages
import messages from './messages/Piace_messages';

// Styles
import './styles/Piace.scss';

const propTypes = {
  hasPiaced: PropTypes.bool,
  piaceCount: PropTypes.number,
  piaceClicked: PropTypes.func,
  short: PropTypes.bool,
  small: PropTypes.bool,
  widget: PropTypes.bool,
  nowrap: PropTypes.bool,
};

class Piace extends PureComponent {
  constructor(props) {
    super(props);

    const { piaceCount } = props;
    this.state = { piaceCount };
  }

  componentWillReceiveProps(nextProps) {
    const { piaceCount } = this.state;
    const hasPiaceCount = piaceCount !== undefined && piaceCount !== null;

    if (!hasPiaceCount && nextProps.piaceCount) {
      this.setState({
        piaceCount: nextProps.piaceCount,
      });
    }
  }

  _piaceClicked = event => {
    event.preventDefault();

    if (this.props.hasPiaced) return false;

    const { piaceCount } = this.state;
    const newPiaceCount = piaceCount ? piaceCount + 1 : 1;
    this.setState({
      piaceCount: newPiaceCount,
    });

    const { piaceClicked } = this.props;
    if (piaceClicked) piaceClicked();

    return false;
  };

  render() {
    const { hasPiaced, short, small, widget, nowrap } = this.props;
    const { piaceCount } = this.state;

    const piaceClass = classNames('piace', {
      'piace-clicked': !!hasPiaced,
    });

    const piaceInfo = classNames({
      hidden: !piaceCount && !hasPiaced,
    });

    const piaceInfoFirst = classNames({
      hidden: piaceCount > 0 || !!hasPiaced,
    });

    const smallPiaceIcon = classNames({
      'small-icon': small,
      'widget-icon': widget,
    });

    const piaceText = classNames('piace-count-wrapper', {
      'small-text': small,
      nowrap,
    });

    const piaceWrapper = classNames('piace-inner-wrapper', {
      'small-container': small,
      widget,
    });

    return (
      <div styleName="Piace">
        <div styleName="piace-wrapper">
          <div styleName={piaceWrapper}>
            {!widget && (
              <a styleName={piaceClass} onClick={this._piaceClicked}>
                <i className="fa fa-heart" styleName={smallPiaceIcon} />
              </a>
            )}
            <small styleName={piaceText} className={piaceInfo}>
              {/* !short && <span>(</span> */}
              <span>{piaceCount || 0} </span>

              {short ? (
                <FormattedMessage {...messages.piaceShort} info="Like this" />
              ) : (
                <FormattedMessage
                  {...messages.piace}
                  info="Like this company"
                />
              )}

              {/* !short && <span>)</span> */}
            </small>

            <small styleName={piaceText} className={piaceInfoFirst}>
              {short ? (
                <FormattedMessage
                  {...messages.piaceFirstShort}
                  info="Be first to like this"
                />
              ) : (
                <FormattedMessage
                  {...messages.piaceFirst}
                  info="Be first to like this company"
                />
              )}
            </small>
            {widget && (
              <a styleName={piaceClass} onClick={this._piaceClicked}>
                <i className="fa fa-heart" styleName={smallPiaceIcon} />
              </a>
            )}
          </div>
        </div>
      </div>
    );
  }
}

Piace.propTypes = propTypes;

export default injectIntl(Piace);
